import { Dictionary, NumericDictionary } from 'lodash';
import { includes, LodashIncludes1x2 } from 'lodash/fp';

export const notIncludes =
  <T>(collection: Dictionary<T> | NumericDictionary<T> | null | undefined): LodashIncludes1x2<T> =>
  (target: T): boolean =>
    !includes(target, collection);
